import { render, staticRenderFns } from "./ksmenu.vue?vue&type=template&id=064bbdb8&scoped=true"
import script from "./ksmenu.vue?vue&type=script&lang=js"
export * from "./ksmenu.vue?vue&type=script&lang=js"
import style0 from "./ksmenu.vue?vue&type=style&index=0&id=064bbdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064bbdb8",
  null
  
)

export default component.exports